import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import styles from "@/styles/Card.module.scss";
import classnames from "classnames";
import Image from "next/image";
import { useMemo } from "react";
import VersatileLink from "@/components/VersatileLink";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CardArtwork(_ref) {
  var item = _ref.item,
      className = _ref.className,
      href = _ref.href,
      _ref$linkAttr = _ref.linkAttr,
      linkAttr = _ref$linkAttr === void 0 ? {} : _ref$linkAttr,
      _ref$intersect = _ref.intersect,
      intersect = _ref$intersect === void 0 ? true : _ref$intersect,
      _ref$showValuePlanLab = _ref.showValuePlanLabel,
      showValuePlanLabel = _ref$showValuePlanLab === void 0 ? false : _ref$showValuePlanLab;
  var url = item.thumbnailUrl;
  var progress = parseInt(item.resume_point, 10) / parseInt(item.duration, 10) * 100 || 0;
  var viewProgressBar = useMemo(function () {
    var resumePoint = (item === null || item === void 0 ? void 0 : item.resume_point) || 0;
    var duration = (item === null || item === void 0 ? void 0 : item.duration) || 0;
    return resumePoint > 0 && duration > 0;
  }, [item]);

  var artwork = /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.artwork, className),
    "aria-label": item.name,
    tabIndex: 0,
    role: "link",
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.image,
      children: intersect && /*#__PURE__*/_jsx(Image, {
        src: url,
        alt: item.name,
        layout: "fill",
        objectFit: "contain"
      })
    }), viewProgressBar && /*#__PURE__*/_jsx("div", {
      className: styles.progress,
      children: /*#__PURE__*/_jsx("span", {
        className: styles["progress-bar"],
        children: /*#__PURE__*/_jsx("span", {
          role: "presentation",
          className: styles["progress-completed"],
          style: {
            width: "".concat(progress, "%")
          }
        })
      })
    }), showValuePlanLabel && /*#__PURE__*/_jsx("div", {
      className: styles.valueplanLabel,
      children: /*#__PURE__*/_jsx(Image, {
        src: "/images/valueplan_label.png",
        alt: "valueplan_label",
        layout: "fill",
        objectFit: "cover"
      })
    })]
  });

  if (href) {
    return /*#__PURE__*/_jsx(VersatileLink, {
      href: href,
      children: /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({}, linkAttr), {}, {
        children: artwork
      }))
    });
  } else {
    return artwork;
  }
}